import styled from 'styled-components';

export const Content = styled.div`
  box-sizing: border-box;
  position: absolute;
  left: ${(props) => props.left};
  top: ${(props) => props.top};
  min-width: 130px;
  /* height: 58px; */
  padding: 10px;
  /* background-color: #13161a; */
  background-color: #1a1a1a;
  border: 1px solid #888;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.58);
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* padding: 0 10px; */
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  text-align: right;

  &.in-window {
    position: static;
    left: auto;
    top: auto;
    margin-right: 1px;
    min-width: 0;
    width: 125px;
    border-color: #a3b0c0;
    cursor: default;
    border-radius: 4px;
    padding: 6px;
    box-shadow: none;
    .zone-icon {
      height: 28px;
      width: 28px;
      border-radius: 7px;
      padding: 3px;
      b {
        width: 21px;
        font-size: 12px;
        border-radius: 7px;
      }
    }
  }
`;

export const Number = styled.div`
  font-size: 22px;
  color: #ccc;
  font-family: 'Conv_LCDNOVA';
  letter-spacing: 5px;
  /* padding-right: 5px; */
  text-align: right;
`;
